import React from "react"
import { Box, Image } from "@chakra-ui/react"
import placeholderLogo from "assets/images/placeholder-logo.svg"
import { DioboxEvent } from "sharedTypes"
import { PREVIEW_PADDING } from "../PreviewFrameWithBranding/PreviewFrameWithBranding"

type Props = {
  event: DioboxEvent
}

const PortalLogo = ({
  event: {
    portalShowLogo,
    portalLogoUrl,
  },
}: Props) => {
  let portalLogo
  if (portalShowLogo) {
    portalLogo = (
      <Box w={160} h={66}>
        {portalLogoUrl ? (
          <Box
            w="100%"
            h="100%"
            bgImage={`url('${portalLogoUrl}')`}
            bgRepeat="no-repeat"
            bgSize="contain"
            borderRadius="md"
            data-testid="portal-logo"
          />
        ) : (
          <Image w="100%" h="100%" src={placeholderLogo} data-testid="portal-logo" />
        )}
      </Box>
    )
  }

  return (
    <Box px={PREVIEW_PADDING} pt={5}>{portalLogo}</Box>
  )
}

export default PortalLogo
